import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const Loader: React.FC = () => (
  <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <Spin indicator={<LoadingOutlined style={{ fontSize: '48px' }} spin />} size="large" />
  </div>
);

export default Loader;